import { createAction } from "@reduxjs/toolkit";

export const setTrackingDetails = createAction<any>("order/setTrackingDetails");
